import React from "react";
import NewButton, { NewButtonVariant, NewButtonSize } from "./NewButton";

const NewButtonExamples: React.FC = () => {
  return (
    <div
      style={{
        padding: "32px",
        backgroundColor: "#020e19",
        minHeight: "100vh",
        color: "white",
      }}
    >
      <section style={{ marginBottom: "32px" }}>
        <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
          <NewButton variant={NewButtonVariant.Primary}>Primary</NewButton>
          <NewButton variant={NewButtonVariant.Secondary}>Secondary</NewButton>
          <NewButton variant={NewButtonVariant.Success}>Success</NewButton>
          <NewButton variant={NewButtonVariant.Danger}>Danger</NewButton>
          <NewButton variant={NewButtonVariant.Warning}>Warning</NewButton>
          <NewButton variant={NewButtonVariant.Info}>Info</NewButton>
          <NewButton variant={NewButtonVariant.Light}>Light</NewButton>
          <NewButton variant={NewButtonVariant.Dark}>Dark</NewButton>
          <NewButton variant={NewButtonVariant.Outline}>Outline</NewButton>
          <NewButton variant={NewButtonVariant.Ghost}>Ghost</NewButton>
        </div>
      </section>

      <section style={{ marginBottom: "32px" }}>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            gap: "16px",
          }}
        >
          <NewButton size={NewButtonSize.Small}>Small</NewButton>
          <NewButton size={NewButtonSize.Medium}>Medium</NewButton>
          <NewButton size={NewButtonSize.Large}>Large</NewButton>
          <NewButton size={NewButtonSize.ExtraLarge}>Extra Large</NewButton>
        </div>
      </section>

      <section style={{ marginBottom: "32px" }}>
        <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
          <NewButton>Normal</NewButton>
          <NewButton isLoading>Loading</NewButton>
          <NewButton isDisabled>Disabled</NewButton>
        </div>
      </section>

      <section style={{ marginBottom: "32px" }}>
        <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
          <NewButton
            leftIcon={<span>📁</span>}
            variant={NewButtonVariant.Primary}
          >
            Otwórz folder
          </NewButton>
          <NewButton
            rightIcon={<span>→</span>}
            variant={NewButtonVariant.Success}
          >
            Dalej
          </NewButton>
          <NewButton
            leftIcon={<span>💾</span>}
            rightIcon={<span>✓</span>}
            variant={NewButtonVariant.Info}
          >
            Zapisz zmiany
          </NewButton>
        </div>
      </section>

      <section style={{ marginBottom: "32px" }}>
        <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
          <NewButton
            onlyIcon
            variant={NewButtonVariant.Primary}
            title="Otwórz folder"
          />
          <NewButton
            onlyIcon
            leftIcon={<span>💾</span>}
            variant={NewButtonVariant.Success}
            title="Zapisz"
          />
          <NewButton
            onlyIcon
            leftIcon={<span>🗑️</span>}
            variant={NewButtonVariant.Danger}
            title="Usuń"
          />
          <NewButton
            onlyIcon
            leftIcon={<span>✏️</span>}
            variant={NewButtonVariant.Warning}
            title="Edytuj"
          />
          <NewButton
            onlyIcon
            leftIcon={<span>ℹ️</span>}
            variant={NewButtonVariant.Info}
            title="Informacje"
          />
          <NewButton
            onlyIcon
            leftIcon={<span>⚙️</span>}
            variant={NewButtonVariant.Secondary}
            title="Ustawienia"
          />
        </div>
      </section>

      <section style={{ marginBottom: "32px" }}>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            gap: "16px",
          }}
        >
          <NewButton
            onlyIcon
            size={NewButtonSize.Small}
            leftIcon={<span>📁</span>}
            variant={NewButtonVariant.Primary}
            title="Mały przycisk"
          />
          <NewButton
            onlyIcon
            size={NewButtonSize.Medium}
            leftIcon={<span>📁</span>}
            variant={NewButtonVariant.Primary}
            title="Średni przycisk"
          />
          <NewButton
            onlyIcon
            size={NewButtonSize.Large}
            leftIcon={<span>📁</span>}
            variant={NewButtonVariant.Primary}
            title="Duży przycisk"
          />
          <NewButton
            onlyIcon
            size={NewButtonSize.ExtraLarge}
            leftIcon={<span>📁</span>}
            variant={NewButtonVariant.Primary}
            title="Bardzo duży przycisk"
          />
        </div>
      </section>

      <section style={{ marginBottom: "32px" }}>
        <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
          <NewButton fullWidth variant={NewButtonVariant.Primary}>
            Pełna szerokość - Primary
          </NewButton>
          <NewButton fullWidth variant={NewButtonVariant.Outline}>
            Pełna szerokość - Outline
          </NewButton>
        </div>
      </section>

      <section style={{ marginBottom: "32px" }}>
        <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
          <NewButton rounded variant={NewButtonVariant.Primary}>
            Zaokrąglony
          </NewButton>
          <NewButton rounded variant={NewButtonVariant.Success}>
            Zaokrąglony Success
          </NewButton>
          <NewButton rounded variant={NewButtonVariant.Danger}>
            Zaokrąglony Danger
          </NewButton>
        </div>
      </section>

      <section style={{ marginBottom: "32px" }}>
        <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
          <NewButton outline variant={NewButtonVariant.Primary}>
            Outline Primary
          </NewButton>
          <NewButton outline variant={NewButtonVariant.Success}>
            Outline Success
          </NewButton>
          <NewButton outline variant={NewButtonVariant.Danger}>
            Outline Danger
          </NewButton>
          <NewButton outline variant={NewButtonVariant.Warning}>
            Outline Warning
          </NewButton>
          <NewButton outline variant={NewButtonVariant.Info}>
            Outline Info
          </NewButton>
          <NewButton outline variant={NewButtonVariant.Secondary}>
            Outline Secondary
          </NewButton>
        </div>
      </section>

      <section style={{ marginBottom: "32px" }}>
        <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
          <NewButton
            outline
            leftIcon={<span>📁</span>}
            variant={NewButtonVariant.Primary}
          >
            Outline z ikoną
          </NewButton>
          <NewButton
            outline
            onlyIcon
            leftIcon={<span>💾</span>}
            variant={NewButtonVariant.Success}
            title="Zapisz"
          />
          <NewButton
            outline
            onlyIcon
            leftIcon={<span>🗑️</span>}
            variant={NewButtonVariant.Danger}
            title="Usuń"
          />
        </div>
      </section>

      <section style={{ marginBottom: "32px" }}>
        <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
          <NewButton variant={NewButtonVariant.Primary}>
            Bez marginesu
          </NewButton>
          <NewButton variant={NewButtonVariant.Success} marginLeft={20}>
            Margin lewy 20px
          </NewButton>
          <NewButton variant={NewButtonVariant.Danger} marginRight={30}>
            Margin prawy 30px
          </NewButton>
          <NewButton
            variant={NewButtonVariant.Warning}
            marginLeft={15}
            marginRight={15}
          >
            Marginesy 15px
          </NewButton>
        </div>
      </section>

      <section style={{ marginBottom: "32px" }}>
        <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
          <NewButton variant={NewButtonVariant.Primary} marginLeft="1rem">
            Margin 1rem
          </NewButton>
          <NewButton variant={NewButtonVariant.Success} marginRight="2em">
            Margin 2em
          </NewButton>
          <NewButton
            variant={NewButtonVariant.Info}
            marginLeft="10%"
            marginRight="5%"
          >
            Marginesy %
          </NewButton>
        </div>
      </section>

      <section style={{ marginBottom: "32px" }}>
        <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
          <NewButton
            onlyIcon
            leftIcon={<span>📁</span>}
            variant={NewButtonVariant.Primary}
            marginLeft={10}
            title="Folder"
          />
          <NewButton
            onlyIcon
            leftIcon={<span>💾</span>}
            variant={NewButtonVariant.Success}
            marginRight={15}
            title="Zapisz"
          />
          <NewButton
            leftIcon={<span>🗑️</span>}
            variant={NewButtonVariant.Danger}
            marginLeft={20}
            marginRight={20}
          >
            Usuń z marginesami
          </NewButton>
        </div>
      </section>

      <section style={{ marginBottom: "32px" }}>
        <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
          <NewButton
            leftIcon={<span>📁</span>}
            variant={NewButtonVariant.Primary}
          >
            Emoji ikona
          </NewButton>

          <NewButton
            leftIcon={
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
              </svg>
            }
            variant={NewButtonVariant.Success}
          >
            SVG ikona
          </NewButton>

          <NewButton
            leftIcon={
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
              </svg>
            }
            variant={NewButtonVariant.Info}
          >
            SVG stroke
          </NewButton>

          <NewButton
            leftIcon={
              <div
                style={{
                  width: "16px",
                  height: "16px",
                  backgroundColor: "currentColor",
                  borderRadius: "50%",
                }}
              />
            }
            variant={NewButtonVariant.Warning}
          >
            Komponent React
          </NewButton>

          <NewButton
            leftIcon={
              <span style={{ fontSize: "12px", fontWeight: "bold" }}>+</span>
            }
            variant={NewButtonVariant.Danger}
          >
            Tekst ikona
          </NewButton>
        </div>
      </section>

      <section style={{ marginBottom: "32px" }}>
        <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
          <NewButton
            leftIcon={<span>📁</span>}
            variant={NewButtonVariant.Primary}
            paddingLeft={15}
          >
            Emoji z paddingiem
          </NewButton>

          <NewButton
            leftIcon={
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
              </svg>
            }
            variant={NewButtonVariant.Success}
            paddingLeft={20}
          >
            SVG z paddingiem
          </NewButton>

          <NewButton
            rightIcon={<span>💾</span>}
            variant={NewButtonVariant.Danger}
            paddingRight={25}
          >
            Prawa ikona z paddingiem
          </NewButton>
        </div>
      </section>

      <section style={{ marginBottom: "32px" }}>
        <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
          <NewButton
            leftIcon={
              <img
                src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyIDJMMTMuMDkgOC4yNkwyMCA5TDEzLjA5IDE1Ljc0TDEyIDIyTDEwLjkxIDE1Ljc0TDQgOUwxMC45MSA4LjI2TDEyIDJaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9zdmc+"
                alt="Star"
                width="16"
                height="16"
              />
            }
            variant={NewButtonVariant.Primary}
          >
            Obrazek ikona
          </NewButton>

          <NewButton
            leftIcon={
              <img
                src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyIDJMMTMuMDkgOC4yNkwyMCA5TDEzLjA5IDE1Ljc0TDEyIDIyTDEwLjkxIDE1Ljc0TDQgOUwxMC45MSA4LjI2TDEyIDJaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9zdmc+"
                alt="Star"
                width="16"
                height="16"
              />
            }
            variant={NewButtonVariant.Success}
            paddingLeft={20}
          >
            Obrazek z paddingiem
          </NewButton>

          <NewButton
            onlyIcon
            leftIcon={
              <img
                src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyIDJMMTMuMDkgOC4yNkwyMCA5TDEzLjA5IDE1Ljc0TDEyIDIyTDEwLjkxIDE1Ljc0TDQgOUwxMC45MSA4LjI2TDEyIDJaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9zdmc+"
                alt="Star"
                width="16"
                height="16"
              />
            }
            variant={NewButtonVariant.Info}
            title="Tylko obrazek"
          />
        </div>
      </section>

      <section style={{ marginBottom: "32px" }}>
        <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
          <NewButton variant={NewButtonVariant.Primary}>
            Nieaktywny Primary
          </NewButton>
          <NewButton variant={NewButtonVariant.Primary} isActive>
            Aktywny Primary
          </NewButton>

          <NewButton variant={NewButtonVariant.Success}>
            Nieaktywny Success
          </NewButton>
          <NewButton variant={NewButtonVariant.Success} isActive>
            Aktywny Success
          </NewButton>

          <NewButton variant={NewButtonVariant.Danger}>
            Nieaktywny Danger
          </NewButton>
          <NewButton variant={NewButtonVariant.Danger} isActive>
            Aktywny Danger
          </NewButton>
        </div>
      </section>

      <section style={{ marginBottom: "32px" }}>
        <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
          <NewButton outline variant={NewButtonVariant.Primary}>
            Nieaktywny Outline
          </NewButton>
          <NewButton outline variant={NewButtonVariant.Primary} isActive>
            Aktywny Outline
          </NewButton>

          <NewButton outline variant={NewButtonVariant.Success}>
            Nieaktywny Success Outline
          </NewButton>
          <NewButton outline variant={NewButtonVariant.Success} isActive>
            Aktywny Success Outline
          </NewButton>
        </div>
      </section>

      <section style={{ marginBottom: "32px" }}>
        <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
          <NewButton
            leftIcon={<span>📁</span>}
            variant={NewButtonVariant.Primary}
          >
            Nieaktywny z ikoną
          </NewButton>
          <NewButton
            leftIcon={<span>📁</span>}
            variant={NewButtonVariant.Primary}
            isActive
          >
            Aktywny z ikoną
          </NewButton>

          <NewButton
            onlyIcon
            leftIcon={<span>💾</span>}
            variant={NewButtonVariant.Success}
            title="Nieaktywny tylko ikona"
          />
          <NewButton
            onlyIcon
            leftIcon={<span>💾</span>}
            variant={NewButtonVariant.Success}
            isActive
            title="Aktywny tylko ikona"
          />
        </div>
      </section>

      <section style={{ marginBottom: "32px" }}>
        <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
          <NewButton
            onlyIcon
            leftIcon={<span>📁</span>}
            variant={NewButtonVariant.Primary}
            title="Domyślny przycisk"
          />
          <NewButton
            onlyIcon
            leftIcon={<span>📁</span>}
            variant={NewButtonVariant.Success}
            paddingLeft={20}
          />
          <NewButton
            onlyIcon
            leftIcon={<span>📁</span>}
            variant={NewButtonVariant.Danger}
            paddingRight={25}
            title="PaddingRight"
          />
          <NewButton
            onlyIcon
            leftIcon={<span>📁</span>}
            variant={NewButtonVariant.Warning}
            paddingLeft={15}
            paddingRight={15}
            title="Paddingi"
          />
        </div>
      </section>

      <section style={{ marginBottom: "32px" }}>
        <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
          <NewButton
            size={NewButtonSize.Large}
            variant={NewButtonVariant.Success}
            leftIcon={<span>✓</span>}
            rounded
          >
            Duży zaokrąglony z ikoną
          </NewButton>
          <NewButton
            size={NewButtonSize.Small}
            variant={NewButtonVariant.Danger}
            rightIcon={<span>🗑️</span>}
            fullWidth
          >
            Mały pełny szerokości z ikoną
          </NewButton>
          <NewButton
            outline
            rounded
            variant={NewButtonVariant.Primary}
            leftIcon={<span>🎨</span>}
            marginLeft={10}
            marginRight={10}
            paddingLeft={25}
            paddingRight={25}
          >
            Outline z marginesami i paddingami
          </NewButton>
          <NewButton
            isDisabled
            outline
            rounded
            variant={NewButtonVariant.Success}
            leftIcon={<span>🎨</span>}
            marginLeft={10}
            marginRight={10}
            paddingLeft={25}
            paddingRight={25}
          >
            Outline z marginesami i paddingami disabled
          </NewButton>
        </div>
      </section>
    </div>
  );
};

export default NewButtonExamples;
